import AuthorizationHeader from './authorization-header';
import fetch from '../core/fetch';
import { parseResponse } from '../core/fetch/response';

// d.getTimezoneOffset() minutes to rfc3339 format, e.g. 420 becomes -07:00
export const toRFC3339TimezoneOffset = offset => {
  const pad = n => (n < 10 ? `0${n}` : `${n}`);
  if (offset === 0) {
    return '+00:00';
  }
  const sign = offset > 0 ? '-' : '+';
  offset = Math.abs(offset);
  return `${sign}${pad(Math.floor(offset / 60))}:${pad(offset % 60)}`;
};

// changes a Date into a rfc3339 timestamp, e.g. 2019-10-30T15:30:11-07:00
export const toRFC3339 = d => {
  const pad = n => (n < 10 ? `0${n}` : `${n}`);
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(
    d.getHours(),
  )}:${pad(d.getMinutes())}:${pad(d.getSeconds())}${toRFC3339TimezoneOffset(
    d.getTimezoneOffset(),
  )}`;
};

export const create = async sessionId => {
  const date = toRFC3339(new Date());
  const headers = await AuthorizationHeader.getCognitoHeader();
  const url = `${process.env.REACT_APP_CLIENT_LIBRARY_API}/streaks/weekly-session`;
  const params = {
    method: 'POST',
    ...headers,
    body: JSON.stringify({
      'offset-date-time': date,
      'session-id': sessionId,
    }),
  };
  const response = await fetch(url, params);
  return parseResponse(response);
};

export const get = async () => {
  const date = toRFC3339(new Date());
  const [getClient, weeklySessionQuery] = await Promise.all([
    import(/* webpackChunkName: "apollo" */ '../core/apollo'),
    import(/* webpackChunkName: "apollo" */ 'apollo-boost'),
  ]).then(([apollo, { gql }]) => [
    apollo.default,
    gql`
      query weeklySession($offset: GetStreakWeeklySessionInput!) {
        streakWeeklySession(input: $offset) {
          milestones
          milestoneGoal
          milestoneCompletedToday
          daysRemaining
        }
      }
    `,
  ]);
  const resp = await (await getClient()).query({
    query: weeklySessionQuery,
    variables: {
      offset: { offsetDateTime: date },
    },
  });
  const respData = resp.data.streakWeeklySession;
  return {
    milestones: respData.milestones,
    'days-remaining': respData.daysRemaining,
    'milestone-completed-today': respData.milestoneCompletedToday,
    'milestone-goal': respData.milestoneGoal,
  };
};

export const remove = async () => {
  const headers = await AuthorizationHeader.getCognitoHeader();
  const url = `${process.env.REACT_APP_CLIENT_LIBRARY_API}/streaks`;
  const response = await fetch(url, {
    method: 'DELETE',
    ...headers,
  });
  return parseResponse(response);
};
